import styled from "@emotion/styled";
import type { PublicKey } from "@solana/web3.js";
import type { DOMAttributes, FC } from "react";
import React from "react";

import { TokenIcon } from "../TokenIcon";

type SwapTokenInfo = {
  mint: string | PublicKey;
  symbol: string;
};
type SwapTokenInfoDisplayProps = SwapTokenInfo & {
  className?: string;
  onClick?: DOMAttributes<HTMLDivElement>["onClick"];
};

const BaseSwapTokenInfoDisplay: FC<SwapTokenInfoDisplayProps> = ({ mint, symbol, className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      <TokenIcon mintAddress={mint} size={12} style={{ marginRight: "0px", marginTop: "0px" }} />
      <span>{symbol}</span>
    </div>
  );
};

export const SwapTokenInfoDisplay = styled(BaseSwapTokenInfoDisplay)`
  display: inline-flex;
  align-items: center;
  span {
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
  }

  img {
    margin-right: 5px !important;
    width: 16px;
    height: 16px;
  }

  > div {
    height: 1rem !important;
    width: 1rem !important;
    border-radius: 1.125rem;
    margin: 0.2rem 0.2rem 0.2rem 0.1rem;
  }
`;
